export default __webpack_public_path__ + "static/media/logo.16efaf42.svg";